import Slider  from 'rc-slider';
import 'rc-slider/assets/index.css';
import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import {FileUploader} from "react-drag-drop-files";

import {
    Panel,
    PanelHeader,
    Header,
    Button,
    Group,
    Cell,
    Div,
    Avatar,
    Alert,
    View,
    Placeholder,
    FormItem, ScreenSpinner
} from '@vkontakte/vkui';
import "../css/home.css"
import FileUpload from "../components/FileUpload";
import {BsFillCartFill, BsTrash, BsEye} from "react-icons/bs";
import {TiInfoLarge} from "react-icons/ti";
import {RiImageEditFill} from "react-icons/ri";
import Logo from "../img/Logo_Circle_300px.png"
import File from "../components/File";
import Image from "../rest/Image";
import CustomPopout from "../components/CustomPopout";
import FileUploadProgress from "../components/FileUploadProgress";

const fileTypes = ["JPG","JPEG", "PNG", "HEIC", "TIFF", "BMP", "WEBP"];
/** Макс. размер одного загружаемого файла (байты). Должно совпадать с UPLOAD_FILE_LIMIT на сервере; при сборке можно задать REACT_APP_UPLOAD_MAX_BYTES. */
const MAX_UPLOAD_FILE_BYTES = Number(process.env.REACT_APP_UPLOAD_MAX_BYTES || 10 * 1024 * 1024);
import $ from "jquery"
import SomeError from "../components/SomeError";
import {VscError} from "react-icons/vsc";
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import CropImage from "../components/CropImage";
import {isCroppingPathname} from "../isCroppingPath";
import {BsImage} from "react-icons/bs";
import OrderDetails from "../components/OrderDetails";
import TakeOrder from "../components/TakeOrder";
import User from "../rest/User";
import PreviewPhotos from "../components/PreviewPhotos";
import {buildOrderPreviewPhotosFromFiles} from "../utils/buildOrderPreviewPhotos";
import SuccessCreated from "../components/SuccessCreated";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import {GiRotaryPhone} from "react-icons/gi";
import {BiRotateLeft} from "react-icons/bi";

const FILES_PER_PAGE = 24;
const ORDER_FILES_STORAGE_KEY = "printorder_order_files_v1";
/** Дубль черновика: sessionStorage иногда отказывает (квота/вебвью), новая вкладка пустая и «работает». */
const ORDER_FILES_LOCAL_KEY = "printorder_order_files_ls_v1";
/** Черновик только для /cropping — не смешивать с основным сайтом и старыми ключами id. */
const ORDER_FILES_CROPPING_SESSION = "printorder_order_files_cropping_v1";
const ORDER_FILES_CROPPING_LOCAL = "printorder_order_files_cropping_ls_v1";

const getDraftStorageKeys = (isCropping) =>
	isCropping
		? {session: ORDER_FILES_CROPPING_SESSION, local: ORDER_FILES_CROPPING_LOCAL}
		: {session: ORDER_FILES_STORAGE_KEY, local: ORDER_FILES_LOCAL_KEY};

const ORDER_FILE_PERSIST_KEYS = [
    "photo", "borders", "crop", "rotate", "imageSize", "selectedSize", "typeValue",
    "cropImage", "cropModalNaturalSwap", "imageNatural", "owner_key", "delete", "count", "size", "type", "url", "renderedFile",
    "previewThumb",
];

/** Только явное delete:true (старые «мягкие» удаления в черновике). Не использовать !item.delete — ломало бы записи с ложными значениями. */
const isActiveOrderFile = (item) =>
    item != null && typeof item === "object" && item.delete !== true;

const filterActiveDraftFiles = (list) => {
    if (!Array.isArray(list)) {
        return [];
    }
    return list.filter(isActiveOrderFile);
};

const serializeFileItemsForOrderDraft = (files) => {
    if (!Array.isArray(files) || files.length === 0) {
        return [];
    }
    /* Не фильтруем здесь: позиции уже вырезаны из массива при удалении; лишний filter мог отбрасывать валидные объекты. */
    return files.map((item) => {
        const out = {};
        if (!item || typeof item !== "object") {
            return out;
        }
        for (const k of ORDER_FILE_PERSIST_KEYS) {
            if (!Object.prototype.hasOwnProperty.call(item, k)) {
                continue;
            }
            const v = item[k];
            if (v === undefined) {
                continue;
            }
            if (typeof v === "object" && v !== null && typeof Node !== "undefined" && v instanceof Node) {
                continue;
            }
            try {
                JSON.stringify(v);
                out[k] = v;
            } catch (e) {
                /* skip non-serializable */
            }
        }
        return out;
    });
};

const parseDraftRecord = (raw) => {
    if (!raw) {
        return null;
    }
    try {
        const data = JSON.parse(raw);
        if (!data || !Array.isArray(data.files)) {
            return null;
        }
        return data;
    } catch (e) {
        return null;
    }
};

const orderIdsMatch = (a, b) => String(a || "") === String(b || "");

const pickBestDraftForOrder = (orderId, sessionData, localData) => {
    const candidates = [sessionData, localData].filter(
        (d) => d && orderIdsMatch(d.orderId, orderId) && Array.isArray(d.files)
    );
    if (candidates.length === 0) {
        return null;
    }
    candidates.sort((a, b) => {
        const la = a.files.length;
        const lb = b.files.length;
        if (la !== lb) {
            return lb - la;
        }
        const ta = typeof a.savedAt === "number" ? a.savedAt : 0;
        const tb = typeof b.savedAt === "number" ? b.savedAt : 0;
        return tb - ta;
    });
    return candidates[0];
};

const readPersistedOrderDraft = (orderId, isCropping = false) => {
    const empty = {files: [], currentPage: 1};
    if (!orderId) {
        return empty;
    }
    const keys = getDraftStorageKeys(isCropping);
    let sessionData = null;
    let localData = null;
    try {
        sessionData = parseDraftRecord(sessionStorage.getItem(keys.session));
    } catch (e) {
        sessionData = null;
    }
    try {
        localData = parseDraftRecord(localStorage.getItem(keys.local));
    } catch (e) {
        localData = null;
    }
    let data = pickBestDraftForOrder(orderId, sessionData, localData);
    if (!data && isCropping) {
        const legacyS = parseDraftRecord(sessionStorage.getItem(ORDER_FILES_STORAGE_KEY));
        const legacyL = parseDraftRecord(localStorage.getItem(ORDER_FILES_LOCAL_KEY));
        data = pickBestDraftForOrder(orderId, legacyS, legacyL);
    }
    if (!data || !orderIdsMatch(data.orderId, orderId)) {
        return empty;
    }
    const filesClean = filterActiveDraftFiles(data.files);
    const totalPages = Math.max(1, Math.ceil(filesClean.length / FILES_PER_PAGE));
    let page = typeof data.currentPage === "number" && data.currentPage >= 1 ? data.currentPage : 1;
    page = Math.min(page, totalPages);
    return {files: filesClean, currentPage: page};
};

const persistOrderDraft = (orderId, files, currentPage, isCropping = false) => {
    if (orderId == null || String(orderId).trim() === "") {
        return;
    }
    const oid = String(orderId);
    const keys = getDraftStorageKeys(isCropping);
    try {
        const payload = {
            orderId: oid,
            files: serializeFileItemsForOrderDraft(files),
            currentPage,
            savedAt: Date.now(),
        };
        const s = JSON.stringify(payload);
        if (s.length > 4_500_000) {
            return;
        }
        try {
            sessionStorage.setItem(keys.session, s);
        } catch (e) {
            /* quota / private mode */
        }
        try {
            localStorage.setItem(keys.local, s);
        } catch (e) {
            /* quota */
        }
    } catch (e) {
        /* stringify / private mode */
    }
};

const clearOrderDraftStorage = (isCropping = false) => {
    const keys = getDraftStorageKeys(isCropping);
    try {
        sessionStorage.removeItem(keys.session);
    } catch (e) {
        /* ignore */
    }
    try {
        localStorage.removeItem(keys.local);
    } catch (e) {
        /* ignore */
    }
};

const escHtml = (value) =>
    String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

const SkippedOversizedFilesAlert = ({fileNames, onClose}) => (
    <div className="content">
        <span className="alert_title">Размер файлов превышает допустимый!</span>
        <div style={{marginTop: 14, textAlign: "left", maxHeight: "min(45vh, 360px)", overflowY: "auto"}}>
            <div className="font_montserrat w_700" style={{marginBottom: 8, fontSize: 14}}>
                Пропущенные файлы:
            </div>
            <ul style={{margin: 0, paddingLeft: "1.2em", color: "#b91c1c", fontSize: 14}}>
                {fileNames.map((name, i) => (
                    <li key={`${name}-${i}`} style={{wordBreak: "break-all", marginBottom: 4}}>
                        {name}
                    </li>
                ))}
            </ul>
        </div>
        <div className="popout_button">
            <Button type="button" onClick={onClose} mode="secondary" size="l">
                Закрыть
            </Button>
        </div>
    </div>
);

const Home = ({id, go, fetchedUser, uniqId, onOrderSessionReset}) => {
    const isCroppingMode = isCroppingPathname();
    const [sizes, setSizes] = useState([]/*[
        {
            label:"10x15",
            width:102,
            height:152,
            coefficient:parseFloat(String(152/102)).toFixed(2),
            minSize:200,
        },
        {
            label:"13x18",
            width:130,
            height:180,
            coefficient:parseFloat(String(180/130)).toFixed(2),
            minSize:200,
        },
        {
            label:"15x21",
            width:152,
            height:212,
            coefficient:parseFloat(String(212/152)).toFixed(2),
            minSize:200,
        },
        {
            label:"20x20",
            width:202,
            height:202,
            coefficient:parseFloat(String(202/202)).toFixed(2),
            minSize:200,
        },
    ]*/)
    const [borderOptions, setBorderOptions] = useState([
        'Без полей', 'С полями'
    ]);
    const [files, setFiles] = useState(() => readPersistedOrderDraft(uniqId, isCroppingMode).files)
    const filesRef = useRef()
    filesRef.current = files
    const types = [
        {label: "Глянцевая", key: "glan"},
        {label: "Матовая", key: "mat"}
    ]
    const [defaultSize, setDefaultSize] = useState(null)
    const [defaultBorders, setDefaultBorders] = useState('Без полей')
    const defaultSizeRef = useRef(null)
    const defaultBordersRef = useRef('Без полей')
    useEffect(() => {
        defaultSizeRef.current = defaultSize
    }, [defaultSize])
    useEffect(() => {
        defaultBordersRef.current = defaultBorders
    }, [defaultBorders])
    const [shops, setShops] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([])
    const [popout, setPopout] = useState(null)
    const [previewPhoto, setPreviewPhoto] = useState(null)
    const [canvasWidth, setCanvasWidth] = useState(150)
    const [currentPage, setCurrentPage] = useState(() => readPersistedOrderDraft(uniqId, isCroppingMode).currentPage)

    /* До первого paint: подтянуть черновик, если useState инициализировался пустым (гонка id / storage). */
    useLayoutEffect(() => {
        if (!uniqId) {
            return;
        }
        const d = readPersistedOrderDraft(uniqId, isCroppingMode);
        if (d.files.length === 0) {
            return;
        }
        setFiles((prev) => {
            if (prev.length > 0) {
                return prev;
            }
            setCurrentPage(d.currentPage);
            return d.files;
        });
    }, [uniqId, isCroppingMode]);

    const prevUniqIdForDraftRef = useRef(null)
    useEffect(() => {
        if (prevUniqIdForDraftRef.current === null) {
            prevUniqIdForDraftRef.current = uniqId
            return
        }
        if (prevUniqIdForDraftRef.current === uniqId) {
            return
        }
        prevUniqIdForDraftRef.current = uniqId
        const draft = readPersistedOrderDraft(uniqId, isCroppingMode)
        setFiles(draft.files)
        setCurrentPage(draft.currentPage)
        setSelectedFiles([])
    }, [uniqId, isCroppingMode])

    useEffect(() => {
        if (!uniqId) {
            return
        }
        persistOrderDraft(uniqId, files, currentPage, isCroppingMode)
    }, [files, uniqId, currentPage, isCroppingMode])

    useEffect(() => {
        setPopout(<ScreenSpinner/>)
        User.getInfo().then((r) => {
            setShops(r.data.shops)
            let szs = r.data.sizes
                // Backward compatibility: old size documents may not have `allow`
                .filter(x => x && x.allow !== false)
                .map(x => (
                    {...x, coefficient: parseFloat(String(x.height / x.width)).toFixed(2)}
                ));
            setSizes(szs)
            setDefaultSize(szs[0] || null)
            setPopout(null)
        }).catch(() => {
            setPopout(null)
        })
    }, [])
    const saveFile = (key, field, value) => {
        let fls = [...files];
        let file = fls[key];
        if (file) {
            file[field] = value;
            fls[key] = file;
            setFiles([...fls])
        }

    }
    const goBack = () => {
        $(".vkuiView__popout.View__popout").css("display", "block")
        setPreviewPhoto(null)
    }
    const openPreview = (photos) => {
        setPreviewPhoto(<PreviewPhotos sizes={sizes} photos={photos} goBack={goBack}/>)
        $(".vkuiView__popout.View__popout").css("display", "none")
    }
    const openCroppingPreviewResult = () => {
        if (!isCroppingMode) {
            return;
        }
        const photos = buildOrderPreviewPhotosFromFiles(files);
        if (!photos.length) {
            return;
        }
        openPreview(photos);
    }
    const selectFile = (key) => {
        let s = selectedFiles;
        if (s.indexOf(key) === -1)
            s.push(key)
        else
            s.splice(s.indexOf(key), 1);
        setSelectedFiles([...s])
    }
    const [alert_content, setAlertContent] = useState(null);
    const [visible, setVisible] = useState(false)

    const normalizeUploadEntry = (entry) => {
        if (typeof entry === "string") {
            return {photo: entry};
        }
        if (entry && typeof entry === "object" && entry.photo) {
            const o = {photo: entry.photo};
            if (entry.preview) {
                o.previewThumb = entry.preview;
            }
            return o;
        }
        return {photo: String(entry || "")};
    };

    const clearAlert = (_id) => {
        setVisible(false);
        setAlertContent(null);
    };

    const resetUploaderInput = () => {
        const uploaderInput = document.querySelector(".file_uploader")?.firstChild;
        if (uploaderInput) {
            uploaderInput.value = "";
        }
    };

    const handleChange = (file) => {
        if (file && file.length > 0) {
            const list = Array.from(file);
            const skipped = list.filter((f) => f.size > MAX_UPLOAD_FILE_BYTES);
            const allowed = list.filter((f) => f.size <= MAX_UPLOAD_FILE_BYTES);
            const skippedNames = skipped.map((f) => f.name);

            const showSkippedNotice = () => {
                setVisible(true);
                setAlertContent(
                    <SkippedOversizedFilesAlert fileNames={skippedNames} onClose={() => clearAlert()}/>
                );
            };

            if (allowed.length === 0) {
                resetUploaderInput();
                showSkippedNotice();
                return;
            }

            setVisible(true);
            setAlertContent(<FileUploadProgress/>);
            Image.upload(allowed, (e) => {
                $("#prog_upload").html(`${Math.round((100 * e.loaded) / e.total)}%`);
            }).then((r) => {
                resetUploaderInput();
                if (r.data.success && r.data.files.length > 0) {
                    const sizeForNew = defaultSizeRef.current || (sizes && sizes.length ? sizes[0] : null);
                    const fils = r.data.files.map(normalizeUploadEntry).map((o) => {
                        const next = {...o};
                        if (sizeForNew) {
                            next.selectedSize = {...sizeForNew};
                        }
                        next.borders = defaultBordersRef.current;
                        return next;
                    });
                    if (filesRef.current && filesRef.current.length > 0) {
                        let d = filesRef.current;
                        d = d.concat(fils);
                        setFiles(d);
                    } else {
                        setFiles(fils);
                    }
                    if (skippedNames.length > 0) {
                        showSkippedNotice();
                    } else {
                        clearAlert();
                    }
                } else {
                    setAlertContent(<SomeError setVisible={setVisible}/>);
                    let html =
                        "Ошибка:<span style='color: red'>Не удалось загрузить фотографии</span>";
                    if (skippedNames.length > 0) {
                        html += `<p style="margin-top:12px;font-weight:700">Размер файлов превышает допустимый!</p><ul style="text-align:left;margin:8px 0;padding-left:1.2em;color:#b91c1c">${skippedNames
                            .map((n) => `<li style="word-break:break-all">${escHtml(n)}</li>`)
                            .join("")}</ul>`;
                    }
                    $("#error").html(html);
                }
            }).catch((e) => {
                resetUploaderInput();
                setAlertContent(<SomeError setVisible={setVisible}/>);
                const apiMsg =
                    e.response &&
                    e.response.data &&
                    (e.response.data.error || e.response.data.message);
                const msg = apiMsg || e.message || "Ошибка загрузки";
                let html = "Ошибка:<span style='color: red'>" + escHtml(msg) + "</span>";
                if (skippedNames.length > 0) {
                    html += `<p style="margin-top:12px;font-weight:700">Размер файлов превышает допустимый!</p><ul style="text-align:left;margin:8px 0;padding-left:1.2em;color:#b91c1c">${skippedNames
                        .map((n) => `<li style="word-break:break-all">${escHtml(n)}</li>`)
                        .join("")}</ul>`;
                }
                $("#error").html(html);
            });
        }
    };
    useEffect(() => {
        /* document.addEventListener('visibilitychange', function() {
             if (document.visibilityState == 'hidden') {

                 User.deleteTemp(filesRef.current.map(x=>x.photo))
             }

         });
         window.addEventListener("unload",(event) => {
             User.deleteTemp(filesRef.current.map(x=>x.photo))
         });*/
    }, [])
    const [history, setHistory] = useState([]);
    const cropMountSeqRef = useRef(0);
    const openCrop = (key, saveMe, imageSize, selectedSize, crop, hidden = true, rotate = false, modalNaturalSwap = false) => {
        cropMountSeqRef.current += 1;
        const cropMountKey = `crop-${key}-${cropMountSeqRef.current}`;
        setAlertContent(<CropImage key={cropMountKey} hidden={hidden} imageSize={imageSize} selectedSize={selectedSize} cropInit={crop} rotate={rotate}
                                   modalNaturalSwap={modalNaturalSwap}
                                   closePop={(id) => clearAlert(id)} savePop={(crop, imgRef, meta) => {
            saveMe(crop, imgRef, meta)
        }} dk={key} file={files[key]}/>)
        setVisible(true)
    }
    const openDetail = () => {
        setAlertContent(<OrderDetails files={files} sizes={sizes} types={types} closePop={clearAlert}/>)
        setVisible(true)
    }
    const clear_pho = (options = {}) => {
        clearOrderDraftStorage(isCroppingMode)
        setFiles([])
        setSelectedFiles([])
        setCurrentPage(1)
        if (options.newOrderSession && typeof onOrderSessionReset === "function") {
            onOrderSessionReset()
        }
    }
    const clearOrderManual = () => {
        clearAlert()
        setPreviewPhoto(null)
        setPopout(null)
        const input = document.querySelector(".file_uploader") && document.querySelector(".file_uploader").firstChild
        if (input) {
            input.value = ""
        }
        clear_pho({newOrderSession: true})
    }
    const TakeOrderResult = (data) => {
        if (isCroppingMode) {
            clearAlert()
            /* Новый id заказа для следующего сохранения (иначе в БД уже есть документ с прежним order_id). */
            clear_pho({newOrderSession: true})
            return
        }
        if (data.success) {
            setAlertContent(<SuccessCreated clearPhotos={() => clear_pho({newOrderSession: true})} mess={data.mess} clearAlert={() => clearAlert()} success={data.success}/>)
        } else {
            setAlertContent(<SuccessCreated clearPhotos={() => clear_pho({newOrderSession: false})} mess={data.mess} clearAlert={() => clearAlert()} success={data.success}/>)
        }
    }
    const openTakeOrder = () => {
        setAlertContent(<TakeOrder callback={(data) => TakeOrderResult(data)} uniqId={uniqId} openPreview={openPreview}
                                   shops={shops} files={files} sizes={sizes} types={types} closePop={clearAlert}
                                   isCroppingMode={isCroppingMode} autoStart={isCroppingMode}/>)
        setVisible(true)
    }
    useEffect(() => {
        if (visible) {
            $('html, body').css({
                overflow: 'hidden',
                height: '100vh'
            });
            $(".vkuiView__popout.View__popout").show();
        } else {
            $('html, body').css({
                overflowY: 'auto',
                overflowX: 'hidden',

            });
        }
    }, [visible])
    const copyFile = (key) => {
        const src = files[key];
        if (!src) {
            return;
        }
        const file = {...src};
        file.owner_key = key;
        /* Не тащить canvas с исходной строки — ссылки на чужой DOM ломают переключение «с полями» у копии. */
        delete file.canvas;
        delete file.canvas_noborders;
        delete file.canvas_bz;
        /* Свои копии кропа / превью «без полей», иначе две строки делят один объект — useLayoutEffect не перерисует canvas. */
        if (src.crop && typeof src.crop === "object") {
            file.crop = {...src.crop};
        }
        if (src.cropImage && typeof src.cropImage === "object") {
            file.cropImage = {...src.cropImage};
        }
        if (src.imageSize && typeof src.imageSize === "object") {
            file.imageSize = {...src.imageSize};
        }
        setFiles((prev) => [...prev, file]);
    }
    const deleteFile = (key) => {
        const photo = files[key] && files[key].photo;
        setFiles((prev) => {
            const next = [...prev];
            if (key < 0 || key >= next.length) {
                return prev;
            }
            next.splice(key, 1);
            return next;
        });
        if (photo) {
            User.deleteTemp([photo]).catch(() => {});
        }
    }
    const auth = (pass) => {

    }
    const getCartCount = () => {
        let p = files.filter((x) => x && x.delete !== true);

        return p.map(x => x.count || 1).reduce((partialSum, a) => partialSum + a, 0)
    }
    const filesInOrderCaption = (n) => {
        const m100 = n % 100;
        const m10 = n % 10;
        if (m100 >= 11 && m100 <= 14) {
            return "файлов в заказе";
        }
        if (m10 === 1) {
            return "файл в заказе";
        }
        if (m10 >= 2 && m10 <= 4) {
            return "файла в заказе";
        }
        return "файлов в заказе";
    }
    const filesIndexedActive = files
        .map((item, idx) => ({ item, idx }))
        .filter(({ item }) => isActiveOrderFile(item));
    const activeFilesCount = filesIndexedActive.length;
    const totalPages = Math.max(1, Math.ceil(activeFilesCount / FILES_PER_PAGE));
    const startIndex = (currentPage - 1) * FILES_PER_PAGE;
    const endIndex = startIndex + FILES_PER_PAGE;
    const filesOnPage = filesIndexedActive.slice(startIndex, endIndex);
    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    useEffect(() => {
        if (previewPhoto) {
            const prev = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = prev;
            };
        }
        return undefined;
    }, [previewPhoto]);

    return (
        <>
        <View popout={visible ? <CustomPopout content={alert_content}/> : popout} activePanel={id}>
            <Panel id={id}>
                <div className={"home_header "}>
                    <img src={Logo} className={"logo_head"} alt=""/>
                    {isCroppingMode ? (
                        <div className={"home_header__mid"}>
                            <span className={"font_montserrat w_700 home_header__crop_label"}>
                                РЕЖИМ ОБРЕЗКИ
                            </span>
                        </div>
                    ) : (
                        <div className={"home_header__spacer"} aria-hidden/>
                    )}
                    {/*<h4 style={{margin: 0, fontSize: 20}} className={"font_montserrat w_600"}>Фотопечать</h4>*/}
                    <div className={"header_buttons"}>
                        {/*<button className={"group_edit"}>
                            <RiImageEditFill size={20} style={{marginRight: 10}}/>
                            <span>Групповое изменение</span>
                        </button>*/}
                        {/* <button onClick={openDetail} className={"info"}>
                            <TiInfoLarge size={20} style={{marginRight: 10}}/>
                            <span>Состав заказа</span>
                        </button>*/}
                        <button
                            disabled={!files || activeFilesCount === 0 || sizes.length === 0}
                            onClick={openTakeOrder}
                            className={"do_order"}
                        >
                            <BsFillCartFill color={"white"} size={20} style={{marginRight: 10}}/>
                            <span>{isCroppingMode ? "Сохранить" : "Заказать"} - {getCartCount()} фото</span>
                        </button>
                    </div>

                </div>

                <div className={"home_order_strip"}>
                    <div className={"home_order_strip__row"}>
                        <div className={"home_order_strip__stat"} role="status" aria-live="polite">
                            <div className={"home_order_strip__stat_icon"} aria-hidden>
                                <BsImage size={28}/>
                            </div>
                            <div className={"home_order_strip__stat_text"}>
                                <span className={"font_montserrat w_700 home_order_strip__stat_value"}>
                                    {activeFilesCount}
                                </span>
                                <span className={"font_montserrat w_600 home_order_strip__stat_caption"}>
                                    {filesInOrderCaption(activeFilesCount)}
                                </span>
                            </div>
                        </div>
                        {isCroppingMode ? (
                            <button
                                type="button"
                                className={"font_montserrat w_700 home_order_strip__clear"}
                                disabled={activeFilesCount === 0}
                                onClick={openCroppingPreviewResult}
                            >
                                <span className={"home_order_strip__clear_icon"} aria-hidden>
                                    <BsEye size={22}/>
                                </span>
                                <span className={"home_order_strip__clear_label home_order_strip__clear_label_wide"}>
                                    Посмотреть результат
                                </span>
                            </button>
                        ) : null}
                        <button
                            type="button"
                            className={"font_montserrat w_700 home_order_strip__clear"}
                            disabled={activeFilesCount === 0}
                            onClick={clearOrderManual}
                        >
                            <span className={"home_order_strip__clear_icon"} aria-hidden>
                                <BsTrash size={22}/>
                            </span>
                            <span className={"home_order_strip__clear_label"}>Очистить заказ</span>
                        </button>
                    </div>
                </div>

                {/* <div style={{backgroundColor:"red",margin:50,height:152*3.7795275591,width:102*3.7795275591,display:"flex"}}>
                    <div style={{
                        aspectRatio:152/202,
                        backgroundImage:`url(${Image.getFiles(files[1])})`,
                    }} className={"text_im"}/>
                </div>*/}

                <div className={"content"}>

                    <div className={"home_upload_section"}>
                        <FileUploader
                            children={<FileUpload/>}
                            multiple={true}
                            onTypeError={(err) => {
                                if (err === "File type is not supported")
                                    setPopout(<Alert
                                        actions={[
                                            {
                                                title: "Oк",
                                                autoclose: true,
                                                mode: "cancel",
                                            }
                                        ]}
                                        actionsLayout="vertical"
                                        onClose={() => setPopout(null)}
                                        header="Ошибка"
                                        text="Неподдерживаемый тип файла"
                                    />)
                            }}
                            onSelect={() => {}}
                            classes={"file_uploader"}
                            hoverTitle={" "}
                            id={"okl"}
                            ariaLabel="Загрузите или перетащите сюда файлы"
                            handleChange={handleChange} name="file" types={fileTypes}/>
                    </div>
                    <div className={"settings"}>

                        <FormItem
                            className={"default_vls"}
                            top={(
                                <span className={"font_montserrat w_500"} style={{color: "grey", fontSize: 13}}>
                                    Добавлять новые фото, как:
                                </span>
                            )}
                        >
                            <div className="default_inputs">

                                <Dropdown controlClassName={"d53"}  className={"d2 select_sizes"} style={{fontSize: 13}}
                                          options={sizes && sizes.length && sizes.map(x => x.label)} onChange={(e) => {
                                    // let d = [...sizes];
                                    let item = sizes.find(x => x.label === e.value)
                                    //let index = d.indexOf(item)
                                    //let c = {...d[0]};
                                    //d[0] = d[index]
                                    // d[index] = c;
                                    setDefaultSize(item)
                                }} value={defaultSize && defaultSize.label}
                                          placeholder="Выберите размер"/>
                                <div className={"borders_switch"}>
                                    <button
                                        type="button"
                                        className={defaultBorders === "Без полей" ? "active" : ""}
                                        onClick={() => setDefaultBorders("Без полей")}
                                    >
                                        Без полей
                                    </button>
                                    <button
                                        type="button"
                                        className={defaultBorders === "С полями" ? "active" : ""}
                                        onClick={() => setDefaultBorders("С полями")}
                                    >
                                        С полями
                                    </button>
                                </div>
                            </div>
                        </FormItem>
                        <FormItem
                            className={"slider_size"}
                            style={{width: 300}}
                            top={(
                                <span
                                    className={"font_montserrat w_500"}
                                    style={{fontSize: 13, visibility: "hidden"}}
                                    aria-hidden
                                >
                                    Добавлять новые фото, как:
                                </span>
                            )}
                        >
                            <div className={"settings_slider_row"}>
                                <BsImage size={30}/>
                                <Slider handleStyle={[{width:20,height:20,marginTop:0,top:"50%",transform:"translate(-50%,-50%)"}]} onChange={(e) => {
                                    setCanvasWidth(e)
                                }} min={150} max={300}  style={{width: 250, marginRight: 13, marginLeft: 13}} />
                               {/* <Slider
                                    max={300}
                                    min={150}
                                    style={{width: 250, marginRight: 10, marginLeft: 10}}
                                    onChange={(e) => {
                                        setCanvasWidth(e)
                                    }}
                                />*/}
                                <BsImage size={50}/>
                            </div>

                        </FormItem>
                    </div>
                    <div className={"files"} style={{marginBottom: 50}}>
                        {files && sizes && sizes.length > 0 && activeFilesCount > 0 ?
                            (filesOnPage.map(({ item, idx: key }) => (
                                <File
                                    defaultSize={defaultSize}
                                    defaultBorders={defaultBorders}
                                    deleteFile={() => deleteFile(key)} copyFile={() => copyFile(key)} types={types}
                                    saveFile={(field, value) => {
                                        saveFile(key, field, value)
                                    }}
                                    canvasWidth={canvasWidth} sizes={sizes}
                                    openCrop={(saveMe, imageSize, selectedSize, crop, hidden, rotate, modalNaturalSwap) => openCrop(key, saveMe, imageSize, selectedSize, crop, hidden, rotate, modalNaturalSwap)}
                                    key={`${uniqId}-${String(item.photo)}-${key}`}
                                    selectedFiles={selectedFiles} item={item}
                                    selectFile={() => selectFile(key)} wh={key} photo={item.photo}/>
                            ))) :
                            <Placeholder icon={<VscError size={54} color={"rgb(177,177,177)"}/>}>
                                Пока тут ничего нет, загрузите фотографии
                            </Placeholder>

                        }
                        {/*<File/>*/}
                    </div>
                    {activeFilesCount > FILES_PER_PAGE && (
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: 12, marginTop: 20, width: "80%", alignSelf: "center"}}>
                            <Button size="m" mode="secondary" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                                Назад
                            </Button>
                            <span className={"font_montserrat w_700"} style={{minWidth: 120, textAlign: "center"}}>
                                Страница {currentPage} / {totalPages}
                            </span>
                            <Button size="m" mode="secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                                Вперед
                            </Button>
                        </div>
                    )}
                </div>
                <div className="hdhdh">
                    <div className={"hdh_info"}>
                        <BiRotateLeft size={50} color={"white"}/>
                        <span className={"font_montserrat w_700"} style={{color:"white"}}>
                            Работать удобнее в вертикальном режиме :-)
                        </span>
                    </div>
                </div>

            </Panel>
        </View>
        {previewPhoto ? createPortal(previewPhoto, document.body) : null}
        </>
    )
};

Home.propTypes = {
    id: PropTypes.string.isRequired,
    go: PropTypes.func.isRequired,
    uniqId: PropTypes.string,
    onOrderSessionReset: PropTypes.func,
    fetchedUser: PropTypes.shape({
        photo_200: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        city: PropTypes.shape({
            title: PropTypes.string,
        }),
    }),
};

export default Home;
